import React from "react";

function ModernAuthField({
	id,
	label,
	type = "text",
	name,
	placeholder,
	value,
	onChange,
	autoComplete,
	autoFocus,
	required,
	suffix,
	error,
	hint,
	maxLength,
	inputMode,
	children,
	className = "",
}) {
	return (
		<div className={className}>
			{label && (
				<label
					htmlFor={id}
					className="mb-1.5 block text-xs font-medium text-zinc-700"
				>
					{label}
				</label>
			)}
			{children ? (
				children
			) : (
				<div
					className={`flex items-center overflow-hidden rounded-lg border transition-all duration-150 focus-within:border-zinc-900 focus-within:ring-1 focus-within:ring-zinc-900 ${
						error ? "border-red-400" : "border-zinc-200"
					}`}
				>
					<input
						id={id}
						type={type}
						name={name}
						placeholder={placeholder}
						value={value}
						onChange={onChange}
						autoComplete={autoComplete}
						autoFocus={autoFocus}
						required={required}
						maxLength={maxLength}
						inputMode={inputMode}
						className="flex-1 bg-white px-3.5 py-2.5 text-sm text-zinc-900 outline-none placeholder:text-zinc-400"
					/>
					{suffix && (
						<div className="border-l border-zinc-200 px-3">{suffix}</div>
					)}
				</div>
			)}
			{error && <p className="mt-1.5 text-xs text-red-500">{error}</p>}
			{!error && hint && <p className="mt-1.5 text-xs text-zinc-400">{hint}</p>}
		</div>
	);
}

export default ModernAuthField;
